<!-- 订单状态table -->
<template>
    <el-table border :header-cell-style="{
        backgroundColor: '#FDEFE7', color: '#000000'
    }" :data="tableData" style="width: 100%">
        <el-table-column align="center" prop="date" label="订单状态" width="180">
            <template slot-scope="scope">
                <div v-for="(n, m) in scope.row.statusDescription" :key="m"
                    style="font-size: 0.12rem;margin-bottom: 0.05rem;">
                    <span style="color: red;margin-right: 0.2rem;">{{ n.statusText }}</span>
                    <span style="color: #3A8477;">{{ n.num }}个子订单</span>
                </div>
            </template>
        </el-table-column>
        <el-table-column align="center" prop="name" label="操作时间" width="180">
            <template slot-scope="scope">
                {{ scope.row.createTime | dateFormatHms }}
            </template>
        </el-table-column>
        <el-table-column align="center" prop="address" label="操作" width="180">

        </el-table-column>
    </el-table>
</template>
<script>
export default {
    props: {
        tableData: {
            type: Array,
            default: () => []
        }
    },
    components: {},
    data() {
        return {

        }
    },
    computed: {},
    watch: {},
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped></style>